import { render, staticRenderFns } from "./ChatMessages.vue?vue&type=template&id=3176af7c&scoped=true"
import script from "./ChatMessages.vue?vue&type=script&lang=js"
export * from "./ChatMessages.vue?vue&type=script&lang=js"
import style0 from "./ChatMessages.vue?vue&type=style&index=0&id=3176af7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3176af7c",
  null
  
)

export default component.exports